import * as React from 'react';
import { listInputElementWidthLinesContext } from './context';
export function ListInputElementWidthLinesProvider(props) {
    var _a = props.elementWidthLines, elementWidthLines = _a === void 0 ? 1 : _a, children = props.children;
    return (React.createElement(listInputElementWidthLinesContext.Provider, { value: elementWidthLines }, children));
}
